import { ArrowLeft, ArrowUpRight } from "lucide-react";

export default function SubHeader({ cta = true }) {
  return (
    <header className="sticky top-0 z-50 border-b border-sand bg-paper/90 backdrop-blur-md">
      <div className="container-x flex h-[70px] items-center justify-between gap-3">
        <a href="/" data-testid="subheader-brand-logo" className="shrink-0 whitespace-nowrap font-serif text-xl tracking-tight text-ink sm:text-2xl">
          Travel-Tek<span className="text-terra">.</span>
        </a>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="/"
            data-testid="subheader-back-link"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-stone2 transition-colors duration-300 hover:text-ink"
          >
            <ArrowLeft className="h-4 w-4" /> <span className="hidden sm:inline">Back to site</span>
          </a>
          {cta && (
            <a
              href="/#demo"
              data-testid="subheader-demo-btn"
              className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-4 py-2 text-xs font-semibold text-paper transition-colors duration-300 hover:bg-terra sm:px-5 sm:py-2.5 sm:text-sm"
            >
              Book a Demo
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
